import { toneClass } from '../lib/metricTone';
import type { MetricTileModel } from '../types';

// `compact` uppercases the value so volume abbreviations read as units
// ("16.5M"); the default capitalizes, since overview values include prose.
const MetricTile = ({
    value,
    label,
    tone,
    compact = false,
}: MetricTileModel & { compact?: boolean }) => (
    <div className={`bg-muted rounded-xl min-w-0 ${compact ? 'p-3' : 'p-4'}`}>
        <div
            className={`${
                compact ? 'text-xs uppercase' : 'text-sm capitalize'
            } font-semibold leading-none truncate ${toneClass(tone)}`}
        >
            {value ?? '—'}
        </div>
        <div
            className={
                compact
                    ? 'text-[11px] text-muted-foreground mt-2'
                    : 'text-xs text-muted-foreground mt-2.5'
            }
        >
            {label}
        </div>
    </div>
);

export default MetricTile;
